import { Button, cn, type ButtonProps } from "@tcg/ui";

export interface BigButtonProps extends ButtonProps {
  /** Second line under the label (small, muted). */
  hint?: string;
  /** Fill the grid cell / row. */
  block?: boolean;
}

/** The register's ≥ 56 px touch button (design/05 §3) — icon + label (+ hint). */
export function BigButton({ hint, block = false, className, children, ...props }: BigButtonProps) {
  return (
    <Button
      size="pos"
      className={cn(
        "min-h-pos-touch flex-col gap-0.5 py-2 text-lg leading-tight",
        block && "w-full",
        className,
      )}
      {...props}
    >
      <span className="flex items-center gap-2">{children}</span>
      {hint ? <span className="text-xs font-normal opacity-80">{hint}</span> : null}
    </Button>
  );
}
